import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  Image,
  SectionHeader,
  Paragraph,
  Heading,
  Link,
} from 'components';
import './Workspace.scss';

const Workspace = () => (
  <StaticQuery
    query={graphql`
      query {
        sideImage: file(
          relativePath: { eq: "office/boldare-office-view.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 743) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        bottomImage: file(
          relativePath: { eq: "connect/visit-in-boldare-office.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 710) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Section
        color={'gray-light'}
        additionalClass={'connect-page__workspace'}
        spaceless
        fullwidth
      >
        <div className={'w-container w-container--side-left'}>
          <Section
            color={'violet'}
            containerClass={'w-container--left connect-page__right-container'}
          >
            <Row className={'no-gap connect-page__workspace-row'}>
              <Col sm={12} md={12} lg={6}>
                <SectionHeader
                  size={'big'}
                  color={'white'}
                  lineColor={'yellow'}
                  fixed
                >
                  Visit Boldare’s innovative workplace
                </SectionHeader>
                <Paragraph
                  size={'medium'}
                  color={'white'}
                  additionalClass={
                    'connect-page__workspace-description text--default'
                  }
                >
                  The future is unmatched, but we want to catch up with it. Our
                  "tomorrow" will be built on creative technology and humanism.
                  <br />
                  <br />
                  We regularly host visitors from around the world who are
                  interested in innovation, they are observing and learning
                  about the way we work and the teal workspace in which we
                  operate.
                </Paragraph>
                <Paragraph
                  size={'medium'}
                  color={'white'}
                  additionalClass={
                    'text--light connect-page__workspace-description text--default'
                  }
                >
                  In our office, where flexibility is king and people are in
                  first place, we’re not afraid that we will lose the race
                  against time.
                  <br />
                  <br />
                  That’s also why we’ve implemented holacracy - a
                  flat-structured governance system, which allows all employees
                  to respond in agile away to changing circumstances and make
                  independent expert decisions.
                </Paragraph>
              </Col>
              <Col sm={12} md={6} lg={6}>
                <div className={'connect-page__workspace-side-image'}>
                  <Image src={data.sideImage.childImageSharp.fluid} />
                </div>
              </Col>
            </Row>
            <Row className={'no-gap connect-page__workspace-row'}>
              <Col sm={12} md={6}>
                <Image src={data.bottomImage.childImageSharp.fluid} />
              </Col>
              <Col sm={12} md={6}>
                <div className={'connect-page__workspace-box'}>
                  <Heading type={3} color={'white'} size={'big'}>
                    VISIT BOLDARE HQ IN&nbsp;
                    <span className={'text--yellow'}>GLIWICE</span>
                  </Heading>
                  <Paragraph size={'medium'} color={'gray'}>
                    <Link
                      to={
                        'https://www.google.pl/maps/place/Kr%C3%B3lowej+Bony+13,+41-100+Gliwice/'
                      }
                    >
                      <span className={'text--gray'}>
                        ul. Królowej Bony 13
                        <br />
                        Gliwice, 44-100 Poland
                        <br />
                      </span>
                    </Link>
                    <Link to={'tel:+48327390900'}>
                      <span className={'text--gray'}>+48 32 739 09 00</span>
                    </Link>
                  </Paragraph>
                  <Heading type={3} color={'white'} size={'big'}>
                    ... BOLDARE <span className={'text--yellow'}>WARSAW</span>
                  </Heading>
                  <Paragraph size={'medium'} color={'gray'}>
                    <Link
                      to={
                        'https://www.google.pl/maps/place/Jasna+24,+00-001+Warszawa/'
                      }
                    >
                      <span className={'text--gray'}>
                        ul. Jasna 24
                        <br />
                        Warszawa, 00-054 Poland
                        <br />
                      </span>
                    </Link>
                    <Link to={'tel:+48327390900'}>
                      <span className={'text--gray'}>+48 32 739 09 00</span>
                    </Link>
                  </Paragraph>
                  <Heading type={3} color={'white'} size={'big'}>
                    OR BOLDARE <span className={'text--yellow'}>WROCLAW</span>
                  </Heading>
                  <Paragraph size={'medium'} color={'gray'}>
                    <Link
                      to={
                        'https://www.google.pl/maps/place/Hubska+52,+50-502+Wroclaw/'
                      }
                    >
                      <span className={'text--gray'}>
                        ul. Hubska 52/14
                        <br />
                        Wroclaw, 50-502 Poland
                        <br />
                      </span>
                    </Link>
                    <Link to={'tel:+48327390900'}>
                      <span className={'text--gray'}>+48 32 739 09 00</span>
                    </Link>
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </Section>
        </div>
      </Section>
    )}
  />
);

export default Workspace;
